import { yupResolver } from '@hookform/resolvers/yup';
import { Tab } from '@mui/material';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { EquiposUtilizadosOTTableType } from '@/erp/tecnico/orden-trabajo/shared/components/SaveOrdenTrabajo/equipos';
import {
  EstadosActivacionInstallOTEnumChoice,
  ROUTER_PATHS,
  a11yProps,
  activacionInstallOtSchema,
  useTabsFormOnly,
} from '@/shared';

import {
  CustomTabPanel,
  FormTabsOnly,
  TabsFormBoxScene,
} from '@/shared/components/ui';
import {
  AlertSeverityEnum,
} from '@/shared/interfaces';
import { useMaterialesUtilizadosStore } from '@/store/erp';
import { useUiStore } from '@/store/ui';

import { IOrdenServicioCorporativo } from '@/shared/interfaces/erp/orden_servicio_corporativo';
import { ActivacionInstallOTClientDataFormTab, ActivacionInstallOTHoraInitFinFormTab, ActivacionInstaOTActiDataFormTab } from '@/erp/operaciones/activaciones/instalaciones/shared/components';
import { usePutOrdenServicioCorporativo } from '@/shared/actions/erp/tecnico/orden_servicio_corporativo';

const returnUrlActivacionInstallOTPage =
  ROUTER_PATHS.operaciones.tecnicosInstalacionCorpNav;

export type SaveActivacionCorporativoInstallPendingOTProps = {
  titlePageNode?: React.ReactNode;
  titlePage?: string;
  ordenTrabajo: IOrdenServicioCorporativo;
  customReturnUrl?: string;
};


const SaveActivacionCorporativoInstallPendingOT: React.FC<
  SaveActivacionCorporativoInstallPendingOTProps
> = ({
  ordenTrabajo,
  titlePage,
  customReturnUrl = returnUrlActivacionInstallOTPage,
  titlePageNode = null,
}) => {
    ///* hooks ------------------------
    const navigate = useNavigate();
    const { handleMethodChange, valueTab } = useTabsFormOnly();

    //useEquiposFlotaActivacionInstall({ ordenTrabajo });

    ///* global state ------------------------
    const equipoSerieUtilizadaActivacion: EquiposUtilizadosOTTableType[] =
      useMaterialesUtilizadosStore(s => s.equipoSerieUtilizadaActivacion);
    const setAlert = useUiStore(s => s.setAlert);
    const clearAllMaterials = useMaterialesUtilizadosStore(
      s => s.clearAllMaterials
    );

    ///* form ------------------------
    /* const form = useForm<SaveFormDataActivacionInstallPendingOT>({ */
    const form = useForm<any>({
      resolver: yupResolver(activacionInstallOtSchema) as any,
      defaultValues: {
        estado_activacion: EstadosActivacionInstallOTEnumChoice.GESTIONADA,
        actualizar_nodo_olt: false,
      },
    });

    ///* mutations ------------------------
    const setActivationData = usePutOrdenServicioCorporativo({
      navigate,
      returnUrl: customReturnUrl,
    });

    // const updatePreventa = useUpdatePreventa()

    ///* handlers ------------------------
    //const onSave = async (data: SaveFormDataActivacionInstallPendingOT) => {
    const onSave = async (data: any) => {
      if (!data?.hora_inicio || !data?.hora_fin)
        return setAlert(
          true,
          'Debe ingresar la hora de inicio y fin de la instalación.',
          AlertSeverityEnum.error
        );

      ///* validate serie ONT -------------
      let thereIsSerieONT = false;
      //let selectedSerie = '';
      for (const item of equipoSerieUtilizadaActivacion) {
        if (item?.selected_series?.length) {
          thereIsSerieONT = true;
          //selectedSerie = item.selectedSeries[0];
          break;
        }
      }
      if (!thereIsSerieONT)
        return setAlert(
          true,
          'Debe ingresar una serie ONT.',
          AlertSeverityEnum.error
        );

      setActivationData.mutate({
        id: ordenTrabajo?.id_orden_servicio_corporativo!,
        data: {
          //actualizar_nodo_olt: data?.actualizar_nodo_olt,
          ipv4_actual: data.ipv4_actual!,
          ipv6_actual: data.ipv6_actual!,
          pppoe: data.pppoe!,
          pppassword: data.pppassword!,
          estado_activacion: EstadosActivacionInstallOTEnumChoice.GESTIONADA,
          hora_inicio: dayjs(data.hora_inicio).format('HH:mm:ss'),
          hora_fin: dayjs(data.hora_fin).format('HH:mm:ss'),
        },
      });
    };

    ///* effects ------------------------
    useEffect(() => {
      if (!ordenTrabajo?.id_orden_servicio_corporativo) return;

      const { prospecto_corporativo_data, preventa_corporativa_data: preventa_coorporativa_data, agendamiento_corporativo_data, ...rest } =
        ordenTrabajo;

      ///* reset form -------------
      form.reset({
        ...prospecto_corporativo_data,
        ...preventa_coorporativa_data,
        ...agendamiento_corporativo_data,
        ...rest,
        /* planLabel: ordenTrabajo?.plan_data?.nombre || '',
        flotaLabel: ordenTrabajo?.flota_data?.nombre || '',
        tipo_instalacion: preventa_data?.tipo_instalacion || '',
        valor_instalacion: preventa_data?.valor_instalacion || '', */

        // observacion_activacion:
        //   ordenTrabajo?.observaciones.observacion_activacion,

        /* ciudad: rest.ciudad_data?.nombre,
        zona: rest.zona_data?.nombre,
        sector: rest.sector_data?.nombre, */
        rawNap: rest.nap_data,
        puerto: rest.puerto!,

        hora_inicio: rest?.hora_inicio
          ? dayjs(rest?.hora_inicio, 'HH:mm:ss')
          : null,
        hora_fin: rest?.hora_fin ? dayjs(rest?.hora_fin, 'HH:mm:ss') : null,
        observacion_activacion: rest?.observaciones?.observacion_activacion,
        coordenadas: rest?.coordenadas,

      } as unknown as any);

      ///* set equipos disponibles -------------
    }, [ordenTrabajo, form.reset]);

    // clean up
    useEffect(() => {
      return () => {
        clearAllMaterials();
      };
    }, []);

    return (
      <TabsFormBoxScene
        titlePage={titlePage!}
        titlePageNode={titlePageNode}
        onCancel={() => {
          navigate(customReturnUrl);
        }}
        onSave={form.handleSubmit(onSave, err => {
          console.log('err', err);
          setAlert(
            true,
            'Debe completar los campos requeridos.',
            AlertSeverityEnum.error
          );
        })}
        tabs={
          <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
            <Tab label="DATOS GENERALES CLIENTE Y HORA INICIO/FIN" value={1} {...a11yProps(1)} />
            <Tab label="DETALLE ACTIVACIÓN" value={2} {...a11yProps(2)} />
            <Tab
              label="MATERIALES"
              value={3}
              {...a11yProps(3)}
            />
          </FormTabsOnly>
        }
      >
        {/* ============ DATOS GENERALES CLIENTE ============ */}
        <CustomTabPanel index={valueTab} value={1}>
          <ActivacionInstallOTClientDataFormTab form={form} />
        </CustomTabPanel>

        {/* ============ DETALLE ACTIVACIÓN ============ */}
        <CustomTabPanel index={valueTab} value={2}>
          <ActivacionInstaOTActiDataFormTab
            form={form}
            /* ordenTrabajo={ordenTrabajo!} */
            ordenTrabajo={ordenTrabajo as any}
          />
        </CustomTabPanel>

        {/* ============ MATERIALES ============ */}
        <CustomTabPanel index={valueTab} value={3}>
          <ActivacionInstallOTHoraInitFinFormTab form={form} />
        </CustomTabPanel>
      </TabsFormBoxScene>
    );
  };

export default SaveActivacionCorporativoInstallPendingOT;
